export default __webpack_public_path__ + "static/media/Wema-Bank-Logo.28ede919.png";